import styled from "styled-components";

export const StyledApplyScheduleToSessionInfoBlock = styled.div`
  background-color: #ebf3ec;
  padding: 8px;
  border-radius: 8px;
`;
export const StyledApplyScheduleToSessionButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: 1.6rem;

  @media (max-width: 425px) {
    flex-direction: column;
    justify-content: initial;
  }
`;
